import React from "react";
import { Switch, Route } from "react-router-dom";
import ProfileOverview from "../profile-overview";

const AffiliateProfileContainer = () => {
  return (
    <Switch>
      <Route path="/account/profile/" component={ProfileOverview} />
    </Switch>
  );
};

export default AffiliateProfileContainer;
